import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { DBConfig, NgxIndexedDBModule } from 'ngx-indexed-db';
import { authInterceptor, provideAuth } from 'angular-auth-oidc-client';

import {
  IndexDBName,
  IS_PRODUCTION,
} from './core/global/constants/constant';
import { httpRequestInterceptor } from './core/interceptors/http-request.interceptor';
import { connectivityInterceptor } from './core/interceptors/retry-on-reconnect.interceptor';
import { routes } from './app.routes';
import { GlobalErrorHandler } from './core/global-error-handler';
import { oidcConfig } from './auth/oidc.config';

const dbConfig: DBConfig = {
  name: IndexDBName,
  version: 1,
  objectStoresMeta: [{
    store: IndexDBName,
    storeConfig: {keyPath: 'key', autoIncrement: false},
    storeSchema: [
      {name: 'key', keypath: 'key', options: {unique: true}},
      {name: 'value', keypath: 'value', options: {unique: false}}
    ]
  }],
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideNoopAnimations(),
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([connectivityInterceptor, authInterceptor(), httpRequestInterceptor])
    ),
    provideAuth(oidcConfig),
    importProvidersFrom(
      NgxIndexedDBModule.forRoot(dbConfig),
    ),
    provideToastr(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: IS_PRODUCTION,
      registrationStrategy: 'registerWhenStable:30000'
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler }
  ],
};
